export function fileTypesArray() {
    let imgTypes = ["png", "jpg", "jpeg", "gif"];
    let videoTypes = ["mp4", "mov", "quicktime"]
    return { videoTypes: videoTypes, imgTypes: imgTypes }
}